// extracted by mini-css-extract-plugin
export default {"wrapper":"UserMenu_wrapper__YvbMI","username":"UserMenu_username__1FENz","logoutButton":"UserMenu_logoutButton__E9kWt"};